import { TooltipTrigger as ArkTooltipTrigger } from '@ark-ui/react/tooltip'

type TooltipTriggerProps = React.ComponentProps<typeof ArkTooltipTrigger>

export function TooltipTrigger({ ...props }: TooltipTriggerProps) {
  return <ArkTooltipTrigger data-testid="tooltip-trigger" {...props} />
}

TooltipTrigger.displayName = 'TooltipTrigger'
